import { isString } from 'lodash';
import { Component, useCallback } from 'react';
import { MBActionSheet } from '@shared/util/actionSheet';
import { i18n } from '@shared/util/i18n';
import { useNavigator } from '@shared/util/navigation';

interface Props {
  cardId: string;
  channelSlug?: string;
  workflowTemplateId?: string | null;
  recurringEntitiesScheduleId?: string;
}

export function useBulkEditMenuItem({
  cardId,
  channelSlug,
  workflowTemplateId,
  recurringEntitiesScheduleId,
}: Props) {
  const { replace } = useNavigator();

  const navigateToBulkUpdate = useCallback(
    (allOrUpcoming: 'all' | 'upcoming') => {
      if (
        isString(channelSlug) &&
        isString(workflowTemplateId) &&
        isString(recurringEntitiesScheduleId)
      ) {
        replace('CardBulkUpdate', {
          cardId,
          channelSlug,
          workflowTemplateId,
          recurringEntitiesScheduleId,
          allOrUpcoming,
        });
      }
    },
    [replace, cardId, channelSlug, workflowTemplateId, recurringEntitiesScheduleId],
  );

  return useCallback(
    (anchor: Component) => {
      MBActionSheet.show({
        parent: anchor,
        title: i18n('card.bulkUpdate.menu.submenu.title'),
        webHorizontalAlignment: 'right',
        options: [
          {
            title: i18n('card.bulkUpdate.menu.submenu.upcomingCards'),
            onPress: () => navigateToBulkUpdate('upcoming'),
          },
          {
            title: i18n('card.bulkUpdate.menu.submenu.allCards'),
            onPress: () => navigateToBulkUpdate('all'),
          },
        ],
      });
    },
    [navigateToBulkUpdate],
  );
}
